@if (isLoaded) {
  <div class="container-fluid" [@fadeInAnimation] (@fadeInAnimation.done)="scrollToArende($event)">
    <div class="row">
      <div class="col-xl-1"></div>
      <div class="col-xl-10">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'gavel']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>Mina ärenden
          </div>
          <div class="card-body">
            @if (allaArenden.length) {
              <div>
                <div class="mb-3">
                  <div class="input-group">
                    <span class="input-group-text">
                        <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                      </span>
                    <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-end" placeholder="Filtrera ärenden" (ngModelChange)="applyFilter()">
                  </div>
                </div>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" [class.order-active]="order==='arendeTyp.typ'" (click)="setOrder('arendeTyp.typ')" title="Ärendetyp">
                          <div class="d-flex justify-content-between">
                            Ärendetyp
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='galdenar.namn'" (click)="setOrder('galdenar.namn')" title="Gäldenär">
                          <div class="d-flex justify-content-between">
                            Gäldenär
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='galdenar.orgnr'" (click)="setOrder('galdenar.orgnr')" title="Organisationsnummer">
                          <div class="d-flex justify-content-between">
                            Org.nr.
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" class="d-none d-lg-table-cell" [class.order-active]="order==='huvudHandlaggare_cache'" (click)="setOrder('huvudHandlaggare_cache')" title="Handläggare">
                          <div class="d-flex justify-content-between">
                            Handläggare
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" [class.order-active]="order==='beslutsdag'" (click)="setOrder('beslutsdag')" title="Konkurs-/beslutsdag">
                          <div class="d-flex justify-content-between">
                            Kk-/beslutsdag
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                        <th scope="col" class="d-none d-lg-table-cell text-end" [class.order-active]="order==='totalAnstallda_cache'" (click)="setOrder('totalAnstallda_cache')" title="Antal anställda">
                          <div class="d-flex justify-content-between">
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="me-2" [flip]="reverse||'vertical'"></fa-icon>
                            Anställda
                          </div>
                        </th>
                        <th scope="col" class="d-none d-lg-table-cell" [class.order-active]="order==='andringsLoggSenast_cache'" (click)="setOrder('andringsLoggSenast_cache')" title="Senast ändrad">
                          <div class="d-flex justify-content-between">
                            Senast ändrad
                            <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (a of allaArenden | orderBy: order:reverse:'case-insensitive' | filterBy: userFilter; track a) {
                        <tr [id]="a.id" class="link" [class.highlighted]="a.id===previousArendeId" [routerLink]="['/mina-arenden', a.id]">
                          <td data-name="Ärendetyp" title="Ärendetyp"><span class="arende-typ-icon" [title]="a.arendeTyp.typ==='rek' ? 'Rekonstruktion' : 'Konkurs'" [style.background-color]="a.arendeTyp.typ==='rek' ? '#1888ff' : '#e14f5d'">{{ a.arendeTyp.typ==='rek' ? 'R' : 'K' }}</span></td>
                          <td data-name="Gäldenär" title="Gäldenär">{{ a.galdenar.namn }}</td>
                          <td data-name="Org.nr." title="Organisationsnummer">{{ a.galdenar.orgnr }}</td>
                          <td data-name="Handläggare" title="Handläggare" class="d-none d-lg-table-cell">{{ a.huvudHandlaggare_cache }}</td>
                          <td [attr.data-name]="a.arendeTyp.typ==='rek' ? 'Beslutsdag' : 'Konkursdag'" [title]="a.arendeTyp.typ==='rek' ? 'Beslutsdag' : 'Konkursdag'">{{ a.beslutsdag | date:'shortDate' }}</td>
                          <td data-name="Anställda" title="Antal anställda i ärendet" class="d-none d-lg-table-cell text-right-sm-left">{{ a.totalAnstallda_cache | number:'1.0-0' }} st</td>
                          <td data-name="Senast ändrad" title="Senast ändrad" class="d-none d-lg-table-cell">{{ a.andringsLoggSenast_cache | date:'shortDate' }}</td>
                        </tr>
                      }
                    </tbody>
                    @if ((allaArenden | filterBy: userFilter).length > 1) {
                      <tfoot>
                        <tr>
                          <th></th>
                          <th colspan="6" title="Antal anställda">{{ (allaArenden | filterBy: userFilter).length | number:'1.0-0' }} st</th>
                        </tr>
                      </tfoot>
                    }
                  </table>
                  @if (!(allaArenden | filterBy: userFilter).length) {
                    <p class="text-muted">Inga träffar</p>
                  }
                </div>
              </div>
            }
            @if (!allaArenden.length) {
              <p class="text-muted">Inga ärenden</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
